import gql from 'graphql-tag';

const archiveAssetsMutation = gql`
    mutation ArchiveAssetsMutation($input: DeleteArchiveAssetsInput!) {
        archiveAssets(input: $input)
    }
`;

const archiveAssets = {
  mutation: archiveAssetsMutation,
  module: 'assets',
  buildVariables: (assetIds) => ({
    input: { assetIds }
  })
};

export default archiveAssets;